export default __webpack_public_path__ + "static/media/thiruvalluvar.6a801796.png";